import React from "react";

export default function PageHeader({ title, subtitle, action, kicker }) {
  return (
    <div className="flex items-end justify-between gap-6 mb-8" data-testid="page-header">
      <div>
        {kicker && <div className="label-tiny mb-2">{kicker}</div>}
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-[#0F1A3D] leading-none">
          {title}
        </h1>
        {subtitle && <p className="text-[#4B5775] mt-2 text-sm max-w-2xl">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
